// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__-oBKi","active":"styles_active__etAOW"};